import React from 'react';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import StarRateIcon from '@mui/icons-material/StarRate';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { alpha } from '@mui/material/styles';

const drinkFields = [
  ['temperature', 'الحرارة'],
  ['taste', 'الطعم'],
];

const FinalDrinkCard = ({
  drink,
  price,
  drinkId,
  approvalLoading,
  approvalDecision,
  rateLoading,
  enableRating,
  onApprove,
  onReject,
  onDetails,
  onRate,
}) => {
  if (!drink) return null;

  const drinkName = drink.drink_name || drink.name || 'مشروب NUVVY';

  return (
    <Paper
      elevation={0}
      sx={(theme) => ({
        mt: { xs: 1.75, md: 3 },
        p: { xs: 1.35, sm: 2, md: 2.5 },
        borderRadius: { xs: 2.5, md: 3 },
        border: `1px solid ${alpha(theme.palette.success.main, 0.22)}`,
        background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.08)}, ${alpha(theme.palette.warning.main, 0.09)})`,
        boxShadow: `0 22px 50px ${alpha(theme.palette.success.main, 0.12)}`,
      })}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" gap={1.5}>
        <Box>
          <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.75 }}>
            <LocalCafeIcon color="warning" />
            <Typography variant="h5" sx={{ fontWeight: 950, color: '#173525' }}>
              {drinkName}
            </Typography>
          </Stack>
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {Number.isFinite(price) && (
              <Chip label={`${price.toFixed(2)} ج.م`} color="warning" sx={{ fontWeight: 900 }} />
            )}
            {drinkFields.map(([key, label]) => (
              drink?.[key] ? (
                <Chip key={key} label={`${label}: ${drink[key]}`} variant="outlined" sx={{ fontWeight: 800 }} />
              ) : null
            ))}
          </Stack>
        </Box>
      </Stack>

      {!drinkId && (
        <Typography variant="caption" color="error.main" sx={{ display: 'block', mt: 1.5 }}>
          لم يتم العثور على drink_id في الاستجابة النهائية.
        </Typography>
      )}

      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="success"
          startIcon={<ThumbUpAltIcon />}
          onClick={onApprove}
          disabled={approvalLoading || approvalDecision === 1 || !drinkId}
          sx={{ borderRadius: 2, fontWeight: 900 }}
          fullWidth
        >
          {approvalLoading && approvalDecision !== 0 ? 'جاري التنفيذ...' : 'قبول المشروب'}
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<ThumbDownAltIcon />}
          onClick={onReject}
          disabled={approvalLoading || approvalDecision === 0 || !drinkId}
          sx={{ borderRadius: 2, fontWeight: 900 }}
          fullWidth
        >
          {approvalLoading && approvalDecision !== 1 ? 'جاري التنفيذ...' : 'جرب حاجة تانية'}
        </Button>
        <Button variant="text" onClick={onDetails} fullWidth sx={{ borderRadius: 2, fontWeight: 800 }}>
          عرض التفاصيل
        </Button>
        {enableRating && (
          <Button
            variant="outlined"
            color="warning"
            startIcon={<StarRateIcon />}
            onClick={onRate}
            disabled={rateLoading || !drinkId}
            sx={{ borderRadius: 2, fontWeight: 900 }}
            fullWidth
          >
            {rateLoading ? 'جاري الإرسال...' : 'تقييم المشروب'}
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default FinalDrinkCard;
